export default {
    disclaimer: "Disclaimer disclaimer-text mt-12",
    text: "",
    white: "theme-white",
    black: "theme-black",
    grey: "theme-grey"
}